import { HemisphereLight } from "three"

export function createHemisphereLight() {
  const hemiLight = new HemisphereLight(0xffffbb, 0x080820, 1)

  // createMountedInverval(() => {
  //   // hemiLight.visible = !hemiLight.visible
  //   hemiLight.intensity = hemiLight.intensity === 1 ? 0.1 : 1
  // }, 1000)

  return hemiLight
}